import { IInteractionsNormalizer } from '../api/repositories/interactions/interactions.normalizer';
import { ActionsUnion, createAction } from '../helpers';

export enum EVisitsActionType {
  POST = 'VISITS/POST',
  POST_SUCCESS = 'VISITS/POST_SUCCESS',
  POST_ERROR = 'VISITS/POST_ERROR',
  GET_VISITS = 'VISITS/GET',
  GET_VISITS_SUCCESS = 'VISITS/GET_SUCCESS',
  RESET = 'VISITS/RESET',
}

export const visitsActions = {
  postVisit: (accountId: string) =>
    createAction(EVisitsActionType.POST, {
      accountId,
    }),
  postVisitSuccess: () => createAction(EVisitsActionType.POST_SUCCESS),
  postVisitError: (accountId: string) =>
    createAction(EVisitsActionType.POST_ERROR, {
      accountId,
    }),
  getVisits: (reset: boolean) =>
    createAction(EVisitsActionType.GET_VISITS, { reset }),
  getVisitsSuccess: (interactions: IInteractionsNormalizer, isSub: boolean) =>
    createAction(EVisitsActionType.GET_VISITS_SUCCESS, {
      ...interactions,
      isSub,
    }),
  resetVisits: () => createAction(EVisitsActionType.RESET),
};

export type IVisitsAction = ActionsUnion<typeof visitsActions>;
